import { Component, h, ComponentInterface, Prop } from '@stencil/core';

@Component({
  tag: 'kdx-comparison-cards',
  styleUrl: 'kdx-comparison-cards.scss',
  shadow: false
})
export class StComparisonCards implements ComponentInterface {

  @Prop() componentScope: string;
  @Prop() ariaLabel: string;

  render() {
    return (
      <section class={`kdx-comparison-cards`} aria-label={this.ariaLabel}>
        <slot />        
      </section>
    );
  }
}